export default __webpack_public_path__ + "static/michael-jackson-9b6f445910f653bf4b87a2edfa7457c4.jpg";